<script>
  import OptionalFilters from './optional-filters/optional-filters.svelte';
  import QuickPicks      from './quick-picks/quick-picks.svelte';
  import ScoreFilters    from './score-filters/score-filters.svelte';
</script>

<style>
  #quick-picks-outer {
    float: left;
    width: 750px;
  }

  #score-filters-outer {
    float: left;
    width: 680px;
  }

  #optional-filters-outer {
    float: left;
    width: 474px;
  }

  #filters :global(.filter-group) {
    margin-bottom: 10px;
  }

  #filters :global(.filter-name) {
    display: inline-block;
    vertical-align: middle;
  }

  #filters :global(.filter-content) {
    display: inline-block;
  }
</style>

<template lang="pug" src="./filters.pug"></template>
